import templatesWorker from "../templatesWorker.js";
import BaseClass from "../BaseClass";
import "easy-autocomplete";

export default class FormHandler extends BaseClass {

    constructor(element) {
        super(element);

        this.formUrl = null;
        this.templatesWorker = null;
        this.errorMessagesContainer = null;
        this.confirmChoiceContainer = null;
        this.$replaceElement = null;
        this.$removeContainer = null;
        this.groupErrors = false;
        // native js prompt/confirm
        this.confirm = null;
        // custom prompt/confirm
        this.renderConfirm = false;
        this.loadingData = false;
        this.submitListener = null;
        this.disposeValidationTooltipListener = null;
        this.submitButton = null;
        this.formElementsLoadedListener = null;
        this.formElementsListener = null;
        this.formElements = [];

        this.init();
    }

    init() {
        let mySelf = this;
        this.formUrl = this.$element.attr('action');
        this.templatesWorker = new templatesWorker();
        this.$replaceElement = null;

        const submitButton = this.$element.find('[data-type="submit-button"]');
        if (submitButton.length > 0) {
            this.submitButton = submitButton;

            this.formElementsLoadedListener = function () {
                mySelf.formElementsLoadedEvent();
            }
            $(document).on('form-elements:loaded', this.formElementsLoadedListener);

            this.formElementsListener = function () {
                mySelf.formElementsEvent();
            }

            const formElements = this.$element.find('[data-type="form-element"]');
            if (formElements.length > 0) {
                this.formElements = formElements;
                this.formElements.on('click', this.formElementsListener);
            }
        }

        let errorMessagesContainer = this.$element.find('[data-type="error-messages-container"]');
        if (errorMessagesContainer.length > 0) {
            this.errorMessagesContainer = errorMessagesContainer;
        }

        let confirmChoiceContainer = this.$element.find('[data-type="confirm-checkbox-container"]');
        if (confirmChoiceContainer.length > 0) {
            this.confirmChoiceContainer = confirmChoiceContainer;
        }

        if (this.$element.attr('data-group-errors') == 1) {
            this.groupErrors = true;
        }

        let replaceElementID = this.$element.attr('data-replaceelement');

        if (replaceElementID != undefined) {
            let $replaceElement = $('#' + replaceElementID);

            if ($replaceElement.length == 1) {
                this.$replaceElement = $replaceElement;
            }
        }

        let removeContainerID = this.$element.data('remove-container');
        if (removeContainerID != undefined) {
            let $removeContainer = $('#' + removeContainerID);
            if ($removeContainer.length == 1) {
                this.$removeContainer = $removeContainer;
            }
        }

        const confirm = this.$element.data('confirm');
        if (confirm != undefined && confirm == true) {
            this.confirm = true;
        }

        const renderConfirm = this.$element.data('render-confirm');
        if (renderConfirm != undefined && renderConfirm == true) {
            this.renderConfirm = true;
        }

        this.$element.on('form:error:add', $.proxy(this.onErrorAdd, this));

        this.$element.on('form:replace:url', function (event, config) {
            event.stopPropagation();

            if (typeof config !== 'undefined' && typeof config.url !== 'undefined') {
                mySelf.replaceFromUrl(config.url);
            }
        });

        this.submitListener = function (event, data) {
            if (event != undefined) {
                event.preventDefault();
                event.stopPropagation();
            }
            if (mySelf.confirm != null) {
                mySelf.handleConfirm(event, data);
            } else {
                mySelf.sendFormData(event, data);
            }
        };

        // error tooltips auflösen
        this.disposeValidationTooltipListener = function (event) {
            const tooltip = bootstrap.Tooltip.getInstance(event.target);
            if (tooltip != null) {
                tooltip.dispose();
            }
            $(event.target).off('focus', this.disposeValidationTooltipListener);
        }

        this.initInfoFields();
        this.initPasswordField();
        this.$element.find('[autofocus]').trigger('focus');

        this.initAutoComplete();
        this.initAutoSubmitter();
        this.initAutoResizeFields();

        this.$element.on('submit', this.submitListener);
        // Submit Button durch Javascript aktivieren
        this.$element.find('fieldset[disabled]').removeAttr('disabled');

        $(document).on('init:password-field', function () {
            mySelf.initPasswordField()
        });
    }

    formElementsLoadedEvent() {
        if (this.formElements.length > 0) {
            this.formElements.off('click', this.formElementsListener);
            this.formElements = [];
        }

        const formElements = this.$element.find('[data-type="form-element"]');
        if (formElements.length > 0) {
            this.formElements = formElements;
            this.formElements.on('click', this.formElementsListener);
        }
    }

    formElementsEvent() {
        let disableButton = true;

        for (let i = 0; i < this.formElements.length; i++) {
            let formElement = $(this.formElements[i]);

            if ('checkbox' == formElement.attr('type') && formElement.is(':checked')) {
                disableButton = false;
            }
        }

        if (!disableButton) {
            this.submitButton.removeAttr('disabled', 'disabled');
        } else {
            this.submitButton.attr('disabled', 'disabled');
        }
    }

    handleConfirm(event, data) {

        if (this.renderConfirm) {

            const $checkbox = this.$element.find('[data-type="confirm-value"]');

            if ($checkbox.filter(':checked').length < 1) {
                const confirm = this.$element.find('[data-type="confirm"]');

                if (confirm.hasClass('hidden')) {
                    confirm.removeClass('hidden');
                    return;
                }

            }

            this.sendFormData(event, data);
        }

        if (!this.renderConfirm && confirm(this.confirm)) {
            this.sendFormData(event, data);
        }

        return;

    }

    initAutoSubmitter() {
        let $autoSubmitter = this.$element.find('[data-type="autosubmitter"]');
        if ($autoSubmitter.length > 0) {
            $autoSubmitter.on("change", this.submitListener);
        }
    }


    initAutoComplete() {
        let mySelf = this;
        let $autoCompleteElements = this.$element.find('[data-type="autocomplete"]');

        if ($autoCompleteElements.length > 0) {

            let options = {
                getValue: function (element) {
                    return element.name;
                },
                ajaxSettings: {
                    dataType: "json",
                    method: "POST",
                    data: {
                        dataType: "json"
                    }
                },
                requestDelay: 300,
                minCharNumber: 3,
                list: {}
            };

            $autoCompleteElements.each(function () {
                let $inputElement = $(this);

                options.url = $inputElement.data('url');
                options.preparePostData = function (data) {
                    data.phrase = $inputElement.val();
                    let postData = $inputElement.data('post-data');

                    if (postData != undefined) {
                        postData.split('&').forEach(function (item) {
                            let itemParts = item.split('=');
                            let key = itemParts[0];
                            data[key] = itemParts[1];
                        });
                    }

                    return data;
                };

                if ($inputElement.data("action-type") == "submit") {
                    options.list.onChooseEvent = mySelf.submitListener;
                }
                $(this).easyAutocomplete(options);
            });
        }
    }


    replaceFromUrl(url) {
        const mySelf = this;

        $(document).trigger('show:loading');
        $.get(url)
            .done(function (data) {
                mySelf.handleResponse(data);
            })
            .always(function () {
                $(document).trigger('hide:loading');
            });
    }

    sendFormData(event, data) {

        if (this.loadingData) {
            return false;
        }

        this.loadingData = true;

        if (!this.validateInputs()) {
            return false;
        }

        let $errorToolTips = $('[validation-name]');

        $errorToolTips.each(function () {
            let tooltip = bootstrap.Tooltip.getInstance($(this).get(0));
            if (tooltip != undefined) {
                tooltip.dispose();
            }
        });

        $(document).trigger('show:loading');

        if (this.errorMessagesContainer != null) {
            this.errorMessagesContainer.html('');
            this.errorMessagesContainer.addClass('hidden');
        }

        if (this.confirmChoiceContainer != null) {
            this.confirmChoiceContainer.prop('checked', false);
            this.confirmChoiceContainer.addClass('hidden');
        }

        if (this.tokenUrl != null) {
            this.regenerateCsrfToken(event);
            return false; // request wird abgebrochen
        }

        this.request(event, data);
    }

    request(event, data) {

        let mySelf = this;

        const useFormData = this.$element.data('use-form-data');

        let postData;

        if (useFormData) {
            postData = new FormData(this.element, event?.originalEvent?.submitter);
        } else {
            postData = new URLSearchParams(this.$element.serialize());
        }

        if (typeof data?.append != 'undefined') {
            for (const key in data.append) {
                postData.append(key, data.append[key])
            }
        }

        let url = this.formUrl;
        if (event?.originalEvent?.submitter) {
            const $submitter = $(event.originalEvent.submitter);

            if ($submitter.is('button[type="submit"][name]')) {
                postData.append($submitter.attr('name'), $submitter.val());
            }

            const formaction = $submitter.attr('formAction');
            if (formaction != undefined) {
                url = formaction;
            }
        }

        let errors = mySelf.$element.find('[data-type="validation_error_holder"]');
        errors.remove();

        let jqxhr;
        if (useFormData) {
            jqxhr = $.ajax({
                method: 'POST',
                url: url,
                processData: false,
                contentType: false,
                data: postData,
                dataType: 'json',
            });
        } else {
            jqxhr = $.post(url, postData.toString(), function () {
            }, 'json');
        }

        jqxhr.done(function (data) {
            mySelf.handleAjaxResponse(data);
        })
            .fail(function (data) {
                if (data.responseJSON != undefined) {

                    if (data.responseJSON.errors != undefined) {
                        mySelf.$element.trigger('form:failing', data.responseJSON.errors);
                        mySelf.addErrors(data.responseJSON.errors);
                    } else {
                        if (jqxhr.status == 419) {
                            window.location.reload();
                        }
                    }
                }
            })
            .always(function () {
                $(document).trigger('hide:loading');
                mySelf.loadingData = false;
            });
    }


    addErrors(errors) {
        let mySelf = this;

        this.$element.addClass('form-validation-error');

        $.each(errors, function (errorName, errorString) {

            if (mySelf.groupErrors) {
                // Fehler sollen in einem einzigen Container gesammelt angezeigt werden.
                mySelf.showErrorsGroup(errorString);
            } else {
                let $validationElements = mySelf.$element.find('[validation-name="' + errorName + '"]');
                // Es gibt explizit ausgezeichnete Elemente für die Fehlermeldungen
                if ($validationElements.length > 0) {
                    $validationElements.each(function () {

                        if (Array.isArray(errorString)) {
                            errorString = errorString[0];
                        }

                        // nur die erste Fehlermeldung wird anzeigt
                        let options = {title: errorString, customClass: 'error', html: true};
                        let domElement = $(this).get(0);
                        let tooltip = new bootstrap.Tooltip(domElement, options);
                        tooltip.show();
                        setTimeout(function () {
                            tooltip.hide();
                        }, 2000);

                        setTimeout(function () {
                            $(domElement).on('focus', mySelf.disposeValidationTooltipListener);
                        }, 75);
                    });
                } else {
                    const fieldParts = errorName.split('.');

                    let fieldName = fieldParts.shift();

                    for (const fieldPart of fieldParts) {
                        fieldName += '[' + fieldPart + ']';
                    }

                    let $inputElement = mySelf.$element.find(':input[name="' + fieldName + '"], fieldset[name="' + fieldName + '"]').first();

                    // Nichts gesondertes gefunden, direkt am Input die Fehlermeldung anzeigen
                    if ($inputElement.length == 1) {
                        mySelf.addErrorContainer($inputElement, errorName, errorString);
                    } else {
                        mySelf.showErrorsGroup(errorString);
                    }
                }
            }
        });
    }

    showErrorsGroup(errorData) {
        if (this.errorMessagesContainer == null) {
            return;
        }
        let errorString;

        if (Array.isArray(errorData)) {
            errorString = errorData.join("<br/>");
        } else {
            errorString = errorData;
        }

        let errorsHTML = "";
        let currentHTML = this.errorMessagesContainer.html();
        if (currentHTML.length > 0) {
            errorsHTML = currentHTML + "<br/>" + errorString;
        } else {
            errorsHTML = errorString;
        }
        this.errorMessagesContainer.html(errorsHTML);

        if (this.errorMessagesContainer.hasClass("hidden")) {
            this.errorMessagesContainer.removeClass('hidden');
        }

        if (this.confirmChoiceContainer && this.confirmChoiceContainer.hasClass('hidden')) {
            this.confirmChoiceContainer.removeClass('hidden');
        }
    }

    addErrorContainer($inputElement, errorName, errorString) {
        let $errorContainer = this.templatesWorker.getTemplate('form_validation_error_tpl');
        $errorContainer.attr('id', 'errorContainer_' + errorName);
        $errorContainer.attr('for', errorName);
        $errorContainer.find('[data-type="message"]').html(errorString);

        $inputElement.after($errorContainer);

        $inputElement.on('click', function () {
            $errorContainer.remove();
        });
        $errorContainer.on('click', function () {
            $errorContainer.remove();
        });
        $inputElement.on('focus', function () {
            $errorContainer.remove();
        });

        setTimeout(function () {
            $errorContainer.remove();
        }, 10000);

    }

    onErrorAdd(event, data) {
        this.addErrors(data.errors);
    }

    initPasswordField() {
        let mySelf = this;
        this.$element.find('.password-show').on('click', function () {
            mySelf.showHidePasswordText(this);
        });
    }

    showHidePasswordText(button) {

        let $parentElement = $(button).parent();
        let $inputElement = $parentElement.children(':input').first();
        let $iconOn = $(button).find('i[data-type=icon-on]');
        let $iconOff = $(button).find('i[data-type=icon-off]');

        if ($inputElement.is(':password')) {
            $inputElement.attr('type', 'text');
            $iconOn.addClass('hidden');
            $iconOff.removeClass('hidden');
        } else {
            $inputElement.attr('type', 'password');
            $iconOff.addClass('hidden');
            $iconOn.removeClass('hidden');
        }
    }


    initInfoFields() {
        let mySelf = this;
        this.$element.find('.input-info').on('mouseover', function () {
            mySelf.showInfoField(this);
        });
    }

    initAutoResizeFields() {
        let autoResize = this.$element.find('[data-autoresize]');
        if (autoResize.length > 0) {
            autoResize.each(function () {
                $(this).on('input', function () {
                    this.style.height = 'auto';
                    this.style.height = this.scrollHeight + 'px';
                });
            });
        }
    }

    showInfoField(field) {

        let $parentElement = $(field).parent();
        let text = $parentElement.data('info');

        let $infoElement = $('<div />', {'class': 'input-info__message', html: text});

        $infoElement.insertAfter($parentElement);

        $(field).on('mouseout', function () {
            $infoElement.remove();
        });
    }


    validateInputs() {

        let mySelf = this;
        const errors = {};
        var regexMail = new RegExp("^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$");
        var regexUserName = new RegExp("^[a-zA-Z0-9-_]+$");
        var regexPassword = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
        var regexoldPassword = new RegExp("^(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");

        let regex = null;
        let $inputFields = this.$element.find(':input');

        $inputFields.each(function () {
                let $element = $(this);
                regex = null;

                switch ($element.data('validator')) {
                    case "email":
                        regex = regexMail;
                        break;

                    case "username":
                        regex = regexUserName;
                        break;

                    case "password":
                        regex = regexPassword;
                        break;

                    case "oldpassword":
                        regex = regexoldPassword;
                        break;

                    case "checkbox":
                        if (!$element.prop('checked')) {
                            let name = $element.attr('name');
                            errors[name] = $element.data('error');
                        }
                        break;
                }


                if (regex != null) {
                    if (!regex.test($element.val())) {
                        let name = $element.attr('name');
                        errors[name] = $element.data('error');
                    }
                }

            }
        );
        if (Object.keys(errors).length > 0) {
            this.addErrors(errors);
            return false;
        }


        return true;
    }

    /**
     * Neuen CSRF-Token laden
     *
     * @returns {boolean}
     */
    regenerateCsrfToken(event) {

        const mySelf = this;
        let url = this.tokenUrl;

        $(document).trigger('show:loading');

        let jqxhr = $.post(url, function () {
            // nix
        }, 'json')
            .done(function (data) {

                // set new csrf token
                $.ajaxSetup({
                    headers:
                        {'X-CSRF-TOKEN': data.token}
                });

                // beabsichtigten Request ausführen
                mySelf.request(event);
            })
            .fail(function (data) {
                // erstmal nichts
            })
            .always(function () {
                $(document).trigger('hide:loading');
            });

        return false;
    }

    destroyListener() {
        this.$element.off('submit', this.submitListener);
        this.$element.off('form:error:add', $.proxy(this.onErrorAdd, this));

        if (this.formElementsLoadedListener != null) {
            $(document).off('form-elements:loaded', this.formElementsLoadedListener);
        }

        if (this.formElements.length > 0) {
            this.formElements.off('click', this.formElementsListener);
        }

        $(document).off('init:password-field');
    }
}